define('studio/laser-edit',["require", "exports", "../baseline/lasers", "../geo/geocoder", "../tracks/track-enabled", "../util/pubsub", "./laser-parse"], function (require, exports, laserApi, geocoder_1, trackEnabled, pubsub_1, laser_parse_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LaserEditor = void 0;
    /**
     * Add or edit a laser profile
     */
    var LaserEditor = /** @class */ (function () {
        function LaserEditor() {
            var _this = this;
            this.saves = new pubsub_1.PubSub();
            // HTML Elements
            this.element = document.getElementById("studio-laser-edit");
            this.laserName = document.getElementById("laser-edit-name");
            this.laserLocation = document.getElementById("laser-edit-location");
            this.laserPublic = document.getElementById("laser-edit-public");
            this.laserUnits = document.getElementById("laser-edit-units");
            this.laserPoints = document.getElementById("laser-edit-points");
            this.formStatus = document.getElementById("laser-form-status");
            // Bind updating on keystroke
            this.laserPoints.onkeyup = function () { return _this.update(); };
            this.laserUnits.onchange = function () { return _this.update(); };
            document.getElementById("laser-save").onclick = function () { return _this.clickSave(); };
        }
        /**
         * Get current profile from editor
         */
        LaserEditor.prototype.getLaserProfile = function () {
            var alt;
            var lat;
            var lng;
            try {
                var location_1 = (0, geocoder_1.parseLatLngAlt)(this.laserLocation.value);
                lat = location_1.lat;
                lng = location_1.lng;
                alt = location_1.alt;
            }
            catch (e) { }
            var metric = this.laserUnits.value === "Meters";
            return {
                laser_id: "laser-tmp",
                user_id: "",
                name: this.laserName.value,
                public: this.laserPublic.value === "Public",
                alt: alt,
                lat: lat,
                lng: lng,
                place: undefined,
                source: "web",
                points: (0, laser_parse_1.text2points)(this.laserPoints.value, metric)
            };
        };
        /**
         * Clear out the laser entry form
         */
        LaserEditor.prototype.clear = function () {
            this.laserName.value = "";
            this.laserLocation.value = "";
            this.laserPoints.value = "";
            this.formStatus.innerText = "";
        };
        /**
         * Validate and post laser profile to server
         */
        LaserEditor.prototype.clickSave = function () {
            var _this = this;
            var laser = this.getLaserProfile();
            if (this.validate(laser)) {
                laserApi.save(laser).then(function (result) {
                    // Result has laser_id
                    _this.clear();
                    // Disable temp laser
                    trackEnabled.remove(laser.laser_id);
                    // Enable new laser
                    trackEnabled.addLaser(result);
                    _this.saves.post(result);
                }).catch(function (error) {
                    console.error(error);
                    _this.formStatus.innerText = "Error: " + error;
                });
            }
        };
        LaserEditor.prototype.validate = function (laser) {
            // Reset error state
            this.formStatus.innerText = "";
            this.laserName.parentElement.classList.remove("has-error");
            this.laserLocation.parentElement.classList.remove("has-error");
            this.laserPoints.parentElement.classList.remove("has-error");
            // Check name
            if (!laser.name) {
                this.laserName.parentElement.classList.add("has-error");
                this.laserName.focus();
                this.formStatus.innerText = "Name cannot be empty";
                return false;
            }
            // Check points
            if (laser.points.length === 0) {
                this.laserPoints.parentElement.classList.add("has-error");
                this.laserPoints.focus();
                this.formStatus.innerText = "No valid measurements";
                return false;
            }
            // Check location
            if (this.laserLocation.value) {
                try {
                    (0, geocoder_1.parseLatLngAlt)(this.laserLocation.value);
                }
                catch (e) {
                    this.laserLocation.parentElement.classList.add("has-error");
                    this.laserLocation.focus();
                    this.formStatus.innerText = e.message;
                    return false;
                }
            }
            return true;
        };
        /**
         * Update the chart as user is entering laser profile
         */
        LaserEditor.prototype.update = function () {
            trackEnabled.addLaser(this.getLaserProfile());
        };
        return LaserEditor;
    }());
    exports.LaserEditor = LaserEditor;
});
//# sourceMappingURL=/assets/javascripts/studio/laser-edit.js.map;
